var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealth = function SvgHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 55 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.127,
    height: 52,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.717 33.718V18.6H8.009L8 44h3.717v-6.776h30.67V44h3.74V33.718z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeWidth: 1.2,
    d: "M35.404 10.655a2.055 2.055 0 1 1-4.11-.001 2.055 2.055 0 0 1 4.11.001Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.738 19.992.001-.002a1.894 1.894 0 0 1 2.567-.769 1.906 1.906 0 0 1 .768 2.57 1.91 1.91 0 0 1-2.57.768 1.896 1.896 0 0 1-.766-2.567ZM13.578 25.053h5.35v6.798h-5.35zM45.376 26.746v5.104H21.68v-6.797h21.869c.65-.002 1.093.202 1.372.477.28.277.457.686.456 1.216Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m35.888 18.254.972 4.257h-6.946L31 18.27a.6.6 0 0 0-.581-.75h-.836a.6.6 0 0 0-.56.386l-1.542 4.017-.01.03c-.139.425-.406.544-.624.547l-.058.004-4.9-.005c-.344 0-.544-.107-.654-.213a.57.57 0 0 1 .003-.819c.113-.109.314-.217.655-.219l4.06.004a.6.6 0 0 0 .561-.386l1.539-4.018.016-.05c.24-.836 1.138-2.235 2.862-2.235h5.052c1.706 0 2.686 1.412 2.97 2.248l1.636 5.7h-1.311l-1.264-4.551a.6.6 0 0 0-.578-.44h-.964a.6.6 0 0 0-.584.734Z"
  })));
};
export default SvgHealth;